<template>
  <div class="header">
    <span class="icon" :class="leftIcon" v-if="showLeft" @click="clickLeft"></span>
    <div class="title">{{title}}</div>
    <span class="icon last-icon" :class="rightIcon" v-if="showRight" @click="clickRight"></span>
    <transition name="van-fade">
      <div class="mask" v-if="showMenu" @click="closeMenu"></div>
    </transition>
    <transition name="slide-right">
      <div class="menu-wrap" v-if="showMenu">
        <div class="row row-wrap">
          <a :href="item.href" class="col-6" v-for="(item,index) in list" :key="index">
            <v-image :src="`/images/icons/menu/menu_0${index+1}.png`"/>
            <span>{{item.title}}</span>
          </a>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  data () {
    return {
      showMenu: false,
      list: [{
        href: '/m',
        title: '微官网'
      }, {
        href: '/wx/index.html?sid=00-0#/questionnaire/entrance',
        title: '体检预约'
      }, {
        href: '/wx/index.html#/topic/list',
        title: '专病专栏'
      }, {
        href: '/wx/index.html#/order/list',
        title: '我的订单'
      }, {
        href: '/wx/index.html#/report/list',
        title: '体检报告'
      }, {
        href: '/wx/index.html#/evaluation/list',
        title: '健康评估'
      }, {
        href: `${this.$route.params.sid || '00-0'}/consult`,
        title: '在线沟通'
      }, {
        href: '/wx/index.html#/user/center',
        title: '个人中心'
      }]
    }
  },
  props: {
    showLeft: {
      type: Boolean,
      default: false
    },
    showRight: {
      type: Boolean,
      default: false
    },
    menu: {
      type: Boolean,
      default: false
    },
    leftIcon: {
      type: String,
      default: 'icon-arrow-left'
    },
    rightIcon: {
      type: String,
      default: 'icon-menu'
    },
    title: {
      type: String,
      default: ''
    }
  },
  methods: {
    closeMenu () {
      this.showMenu = false
    },
    clickLeft () {
      this.$router.go(-1)
    },
    clickRight () {
      if (this.menu) {
        this.showMenu = !this.showMenu
      } else {
        this.$emit('clickRight')
      }
    }
  }

}
</script>

<style lang="scss" scoped>
  @import "@/assets/style/variables.scss";

  .header {
    height: $bar-height;
    //background: #f7f6f9;
    // box-shadow: 0 0 6px #999;
    position: relative;
    //z-index: 1;
    .title {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      height: 100%;
      text-align: center;
      line-height: $bar-height;
      z-index: 0;
    }
    .icon {
      font-size: 20px;
      width: $bar-height - 5;
      height: $bar-height - 5;
      line-height: $bar-height - 5;
      position: absolute;
      text-align: center;
      top: 3px;
      color: $dark06;
      z-index: 1;
      &:first-child {
        left: 0;
      }
      &.last-icon {
        right: 0;
      }
    }
    img {
      display: block;
      height: 100%;
      margin: 0 auto;
    }
  }

  .mask {
    background: rgba(0, 0, 0, 0.35);
    position: fixed;
    top: $bar-height;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 10000;
  }

  .menu-wrap {
    position: fixed;
    right: 0;
    top: $bar-height;
    bottom: 0;
    width: 220px;
    background: $light;
    z-index: 10001;
    padding: 20px 0;
    overflow-y: auto;
    .row {
      .col-6 {
        padding: 20px 0;
        position: relative;
        &:active {
          opacity: 0.8;
        }
      }
      span {
        padding-top: 15px;
        display: block;
        text-align: center;
      }
      img {
        width: 52px;
        height: 52px;
      }
    }
  }
</style>
